import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const AutoPublishIntegrationModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "AutoPublishIntegrationModalContainer" */
      './AutoPublishIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
